import { Component, OnInit, Inject, Injector, OnDestroy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MarkAsApprovalService } from "src/app/shared/services/task-service/mark-as-approval.service";
import { UserDetailsService } from "src/app/shared/services/user-details.service";
import * as CryptoJS from "crypto-js";
import { TasksService } from "src/app/shared/services/task-service/tasks.service";
import {
  discussionSocketEvents,
  DISCUSSION_COMMENT_TYPE,
} from "src/app/shared/global/constants";
import { DiscussionSocketService } from "src/app/shared/services/discussion/discussion-socket.service";
import { UtilsService } from "src/app/shared/services/utils-service/utils.service";
import { TaskEmitService } from "src/app/shared/services/task-service/task-emit.service";
import { TimesheetSettingService } from "src/app/shared/services/organization-settings/timesheet-setting.service";
import { Subscription, take, lastValueFrom } from "rxjs";
import { Store } from "@ngrx/store";
import { SaveReportService } from "src/app/shared/services/report-service/save-report.service";
import { taskState as TaskState } from "src/app/shared/ngrx/reducer/task-state.reducer";
import { taskState } from "src/app/shared/ngrx/action/task-state.actions";
import * as _ from "lodash";
import { CreateTaskComponent } from "../create-task/create-task.component";
import { jsPDF } from "jspdf";
import { TimeSheetService } from "src/app/shared/services/time-sheet-service/time-sheet.service";
@Component({
  selector: "app-add-edit-task",
  templateUrl: "./add-edit-task.component.html",
  styleUrls: ["./add-edit-task.component.scss"],
})
export class AddEditTaskComponent implements OnInit, OnDestroy {
  selectedRoom: any = {};
  task_id: any;
  userId: any;
  markAsApprovalData: any;
  decryptedCompanyId: any;
  companyId: any;
  userRolePermission: any;
  private userDetail: UserDetailsService;
  memberId: any;
  private taskService: TasksService;
  selectedCompanyId: any;
  timeLogDetail: any;
  alluserList: any[] = [];
  readByUserList: any = [];
  timeLogData: any;
  public emitTaskService: TaskEmitService;
  subscription: Subscription;
  taskState: any;
  taskData: any;
  isDraftTask = false;
  workflow_template_id:any;
  isRefreshTaskPageBoolean:any = false;
  printComments: Array<{ author: string; message: string; created_at: string }> = [];
  logActivities: any[] = [];
  timeLogPrintData: {
    totalHours?: string;
    estimatedHours?: string;
    entries: Array<{
      date: string;
      user: string;
      type: string;
      logDate: string;
      start: string;
      end: string;
      hours: string;
      note: string;
    }>;
  } = { entries: [] };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public markAsApprovalService: MarkAsApprovalService,
    private injector: Injector,
    public timeSheetSettingService: TimesheetSettingService,
    private discussionSocketService: DiscussionSocketService,
    public utilsService: UtilsService,
    public timeSheetService: TimeSheetService,
    private store: Store<{ taskState: TaskState }>,
    public reportService: SaveReportService,
    public dialogRef: MatDialogRef<CreateTaskComponent>
  ) {
    this.dialogRef.disableClose = true;
    this.task_id = this.data?.editTaskId;
    this.emitTaskService = injector.get<TaskEmitService>(TaskEmitService);
    this.userDetail = injector.get<UserDetailsService>(UserDetailsService);
    this.taskService = injector.get<TasksService>(TasksService);
  }


  ngOnDestroy() {
    this.selectedRoom = null;
    this.taskService.selectedTaskDetails.next("");
    this.subscription?.unsubscribe();
  }

  onCommentsChanged(comments: any[]) {
    this.printComments = comments || [];
  }

  async ngOnInit() {
    this.updateStoreData();
    this.store.select("taskState").subscribe((ele: any) => {
      if (!ele.taskState) return;
      this.taskState = ele?.taskState;
    });
    this.getTaskDetails();
    this.companyId = await this.userDetail.getSelectedCompanyId();
    this.userId = await this.userDetail.userId;
    this.decryptedCompanyId = CryptoJS.AES.decrypt(
      this.companyId?.trim(),
      ""
    ).toString(CryptoJS.enc.Utf8);
    this.userRolePermission = await this.userDetail.getUserRolePermissions();
    this.memberId = this.userRolePermission?.memberId;
    this.selectedCompanyId = await this.userDetail.getSelectedCompanyId();
    this.task_id = this.data?.editTaskId;
    this.getTimeSheetDetail(this.decryptedCompanyId);
    await this.getMarsAsApprovalFlowData();
    this.subscription = this.emitTaskService.usersList$.subscribe(
      (data: any) => {
        this.alluserList = data;
      }
    );
    this.subscription = this.emitTaskService.readByusersList$.subscribe(
      (data: any) => {
        this.readByUserList = data;
      }
    );
  }

  async getMarsAsApprovalFlowData() {
    const markAsApprove = this.taskState?.markAsApprove;
    this.markAsApprovalData = markAsApprove;
  }

  getTaskDetails() {
    this.subscription = this.taskService.selectedTaskDetails.subscribe(
      (response) => {
        if (response) {
          this.taskData = response;
          this.isDraftTask =
            response?.status?.status_name?.toLowerCase() === "draft";
          const userIDs = response?.user_ids;
          const groupIDs = response?.group_ids;

          let result: any;

          if (userIDs && userIDs.length > 0) {
            result = [...userIDs];
          } else if (groupIDs && groupIDs.length > 0) {
            result = [...groupIDs];
          } else {
            result = [];
          }

          this.selectedRoom = {
            _id: response.task_id,
            user_id: response.owner.user_id,
            title: response.task_name,
            project_id: null,
            task_id: response.task_id,
            color: "#DC3535",
            created_by: response.owner,
            accesses: result,
            type: DISCUSSION_COMMENT_TYPE.TASK,
            avatar: this.utilsService.forShortName(response?.task_name),
            main_avatar: this.utilsService.forShortName(response?.task_name),
            profile_image: "#DC3535",
            taskComment: true,
          };
          if (response.task_id) {
            this.discussionSocketService.emit(
              discussionSocketEvents.LEAVE_ROOM,
              {
                id: this.selectedRoom._id,
              }
            );

            this.discussionSocketService.emit(
              discussionSocketEvents.JOIN_ROOM,
              {
                id: this.selectedRoom._id,
              }
            );
          }
        }
      }
    );
  }

  async onTabChanged(event: any) {
    if (event?.index == 2) {
      this.emitTaskService.setUserList(this.alluserList);
      this.emitTaskService.readByUserList(this.readByUserList);
    }
  }

  async getTimeSheetDetail(company_id: any) {
    (
      await this.timeSheetSettingService.getTimesheetMasterSetting(company_id)
    ).subscribe((res: any) => {
      if (res) {
        this.timeLogData = res.result;
      }
    });
  }

  async updateStoreData() {
    (await this.reportService.filterReport()).subscribe(async (res: any) => {
      const userKeyByValue = _.keyBy(res.result, "id");
      res.result.group_details.map((ele: any) => userKeyByValue[ele]);
      this.store
        .select("taskState")
        .pipe(take(1))
        .subscribe((ele) => {
          const old = JSON.parse(JSON.stringify(ele.taskState));
          old["reportConfig"] = res?.result;
          this.store.dispatch(taskState({ data: old }));
        });
    });
  }

  updateTaskId(event: any) {
    this.task_id = null;
    this.workflow_template_id = null;
    setTimeout(() => {
      this.task_id = event?.task_id;
      if(event?.workflow_template_id && !event?.workflow_parent_id){
        this.workflow_template_id = event?.workflow_template_id
      }
    }, 100);
  }

  getAssigneeNames() {
    if (!this.taskData?.assignees?.length) return "-";
    return this.taskData.assignees
      .map((a: any) => `${a?.first_name || ""} ${a?.last_name || ""}`.trim())
      .filter((name: string) => name.length > 0)
      .join(", ") || "-";
  }

  getFollowerNames() {
    if (!this.taskData?.follower?.length) return "-";
    return this.taskData.follower
      .map((f: any) => {
        const name = `${f?.first_name || ""} ${f?.last_name || ""}`.trim();
        return name || f?.name || f?.email || "-";
      })
      .filter((name: string) => name && name !== "-")
      .join(", ") || "-";
  }

  getClientName() {
    return this.taskData?.client?.name || this.taskData?.client?.client_name || "-";
  }

  getServiceName() {
    return this.taskData?.service?.name || "-";
  }

  getRecurringDetails() {
    const recurring = this.taskData?.recurringTask;
    if (!this.taskData?.is_recurring_task || !recurring) return null;
    const frequency = recurring?.recurring_frequency || "-";
    let value = "-";
    if (Array.isArray(recurring?.recurring_value)) {
      value = recurring.recurring_value.join(", ");
    } else if (recurring?.recurring_value) {
      value = recurring.recurring_value;
    }
    const endDate = recurring?.recurring_end_date
      ? new Date(recurring.recurring_end_date).toDateString()
      : "-";
    const excluded = Array.isArray(recurring?.excluded_days)
      ? recurring.excluded_days.join(", ")
      : "-";
    return { frequency, value, endDate, excluded };
  }

  getCustomFieldLines() {
    const raw = this.taskData?.custom_fields_values || [];
    if (!Array.isArray(raw) || !raw.length) return [];
    const groups = raw.reduce((acc: any, item: any) => {
      const key = item?.custom_field_id || item?.id || item?.field_id;
      if (!acc[key]) acc[key] = [];
      acc[key].push(item);
      return acc;
    }, {});
    return (Object.values(groups) as any[]).map((items: any[]) => {
      const first = items[0] || {};
      const label =
        first?.field?.label ||
        first?.field_name ||
        first?.custom_field_name ||
        first?.label ||
        first?.name ||
        "Custom Field";
      const values = items
        .map((v: any) =>
          v?.value ??
          v?.field_value ??
          v?.custom_field_option_value ??
          v?.custom_field_option_label ??
          v?.option_label ??
          v?.option_value ??
          v?.custom_field_option_id ??
          v?.label ??
          ""
        )
        .filter((v: any) => v !== "" && v !== null && v !== undefined);
      return { label, value: values.length ? values.join(", ") : "-" };
    });
  }

  getOwnerName() {
    if (!this.taskData?.owner) return "-";
    const name = `${this.taskData?.owner?.first_name || ""} ${
      this.taskData?.owner?.last_name || ""
    }`.trim();
    return name || "-";
  }

  getDescriptionText() {
    return this.stripHtml(this.taskData?.description || "-");
  }

  getPriorityText() {
    const priority = this.taskData?.priority;
    if (!priority) return "-";
    if (typeof priority === "string") return priority;
    return (
      priority?.priority_name ||
      priority?.name ||
      priority?.label ||
      "-"
    );
  }

  private stripHtml(value: string) {
    return value
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  async printTaskDetail() {
    await this.loadTimeLogForPrint();
    await this.loadLogActivityForPrint();

    const pdf = new jsPDF("p", "mm", "a4");
    const marginX = 14;
    const pageWidth = 210;
    const pageHeight = 297;
    const maxWidth = pageWidth - marginX * 2;
    let cursorY = 16;

    const primaryColor = { r: 51, g: 204, b: 255 }; // Taskopad primary
    const textDark = { r: 33, g: 33, b: 33 };
    const textMuted = { r: 97, g: 97, b: 97 };
    const divider = { r: 225, g: 225, b: 225 };

    const addLine = (text: string, size = 11, bold = false, muted = false) => {
      pdf.setFont("helvetica", bold ? "bold" : "normal");
      pdf.setFontSize(size);
      if (muted) {
        pdf.setTextColor(textMuted.r, textMuted.g, textMuted.b);
      } else {
        pdf.setTextColor(textDark.r, textDark.g, textDark.b);
      }
      const lines = pdf.splitTextToSize(text || "-", maxWidth);
      lines.forEach((line: string) => {
        if (cursorY > pageHeight - 16) {
          pdf.addPage();
          cursorY = 16;
        }
        pdf.text(line, marginX, cursorY);
        cursorY += size * 0.6 + 2;
      });
    };

    const addCenteredTitle = (text: string, size = 14) => {
      if (cursorY > pageHeight - 30) {
        pdf.addPage();
        cursorY = 16;
      }
      pdf.setFillColor(primaryColor.r, primaryColor.g, primaryColor.b);
      pdf.roundedRect(marginX - 2, cursorY - 6, pageWidth - (marginX - 2) * 2, 12, 2, 2, "F");
      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(size);
      pdf.setTextColor(255, 255, 255);
      const textWidth = pdf.getTextWidth(text);
      const x = (pageWidth - textWidth) / 2;
      pdf.text(text, x, cursorY + 2);
      cursorY += 16;
      pdf.setTextColor(textDark.r, textDark.g, textDark.b);
    };

    const addSectionDivider = () => {
      pdf.setDrawColor(divider.r, divider.g, divider.b);
      pdf.setLineWidth(0.2);
      pdf.line(marginX, cursorY, pageWidth - marginX, cursorY);
      cursorY += 4;
    };

    const addInfoRow = (label: string, value: string) => {
      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(10);
      pdf.setTextColor(textMuted.r, textMuted.g, textMuted.b);
      pdf.text(label, marginX, cursorY);
      pdf.setFont("helvetica", "normal");
      pdf.setTextColor(textDark.r, textDark.g, textDark.b);
      const valueLines = pdf.splitTextToSize(value || "-", maxWidth - 35);
      pdf.text(valueLines, marginX + 35, cursorY);
      cursorY += 6 + (valueLines.length - 1) * 4;
    };

    addCenteredTitle("Task Detail", 16);
    addLine(this.taskData?.task_name || "-", 12, true);
    cursorY += 2;

    addInfoRow("Task Name", this.taskData?.task_name || "-");
    addInfoRow("Description", this.getDescriptionText() || "-");
    addInfoRow("Status", this.taskData?.status?.status_name || "-");
    addInfoRow("Priority", this.getPriorityText());
    addInfoRow(
      "Start Date",
      this.taskData?.start_date
        ? new Date(this.taskData?.start_date).toDateString()
        : "-"
    );
    addInfoRow(
      "Due Date",
      this.taskData?.due_date
        ? new Date(this.taskData?.due_date).toDateString()
        : "-"
    );
    addInfoRow("Created By", this.getOwnerName());
    addInfoRow("Assignees", this.getAssigneeNames());
    if (this.getClientName() !== "-") {
      addInfoRow("Client", this.getClientName());
    }
    if (this.getServiceName() !== "-") {
      addInfoRow("Service", this.getServiceName());
    }
    if (this.getFollowerNames() !== "-") {
      addInfoRow("Followers", this.getFollowerNames());
    }
    const recurring = this.getRecurringDetails();
    if (recurring) {
      addInfoRow("Recurring", "Yes");
      addInfoRow("Frequency", recurring.frequency);
      addInfoRow("Value", recurring.value);
      if (recurring.endDate && recurring.endDate !== "-") {
        addInfoRow("End Date", recurring.endDate);
      }
      if (recurring.excluded && recurring.excluded !== "-") {
        addInfoRow("Excluded Days", recurring.excluded);
      }
    }
    const customFields = this.getCustomFieldLines();
    if (customFields.length) {
      cursorY += 2;
      addLine("Custom Fields", 11, true, true);
      customFields.forEach((field) => {
        addInfoRow(field.label, field.value);
      });
    }
    addSectionDivider();

    if (this.printComments?.length) {
      pdf.addPage();
      cursorY = 16;
      addCenteredTitle("Comments", 14);
      this.printComments.forEach((comment) => {
        addLine(`${comment?.author || "-"} • ${comment?.created_at || "-"}`, 10, true, true);
        addLine(comment?.message || "-", 11, false);
        cursorY += 2;
      });
    }

    if (this.timeLogPrintData?.entries?.length) {
      pdf.addPage();
      cursorY = 16;
      addCenteredTitle("Time Log", 14);
      if (this.timeLogPrintData?.estimatedHours || this.timeLogPrintData?.totalHours) {
        addLine(
          `Est. Hrs: ${this.timeLogPrintData?.estimatedHours || "00:00"} | Actual Hours: ${
            this.timeLogPrintData?.totalHours || "00:00"
          }`,
          10,
          true,
          true
        );
      }
      let currentDate = "";
      this.timeLogPrintData.entries.forEach((entry) => {
        if (entry.date !== currentDate) {
          currentDate = entry.date;
          addLine(currentDate, 11, true, true);
        }
        addLine(
          `${entry.user} • ${entry.type} • ${entry.logDate} • ${entry.start} - ${entry.end} • ${entry.hours}`,
          10,
          false
        );
        if (entry.note) {
          addLine(`Note: ${entry.note}`, 10, false);
        }
        cursorY += 1;
      });
    }

    if (this.logActivities?.length) {
      pdf.addPage();
      cursorY = 16;
      addCenteredTitle("Log Activity", 14);
      this.logActivities.forEach((day: any) => {
        addLine(
          day?.date
            ? new Date(day.date).toDateString()
            : "-",
          11,
          true,
          true
        );
        (day?.data || []).forEach((entry: any) => {
          const time = entry?.createdAt
            ? new Date(entry.createdAt).toLocaleTimeString()
            : "";
          const user = entry?.user_name || "-";
          const text = this.stripHtml(entry?.log || "-");
          addLine(`${time} - ${user}: ${text}`, 10, false);
        });
        cursorY += 2;
      });
    }

    const safeName =
      (this.taskData?.task_name || "Task")
        .toString()
        .replace(/[\\/:*?"<>|]/g, "")
        .trim() || "Task";
    pdf.save(`${safeName}.pdf`);
  }

  private async loadLogActivityForPrint() {
    if (!this.task_id || !this.selectedCompanyId) return;
    try {
      const response = await lastValueFrom(
        await this.taskService.getTaskActivityLog(
          this.task_id,
          this.selectedCompanyId,
          ""
        )
      );
      this.logActivities = response || [];
    } catch (_err) {
      this.logActivities = [];
    }
  }

  private async loadTimeLogForPrint() {
    if (!this.task_id) return;
    try {
      const response = await lastValueFrom(
        await this.timeSheetService.getTimeLog({
          taskId: this.task_id,
          selectUserId: null,
          selectedTaskId: null,
          isPrimary: true,
          offset: this.utilsService.getOffsetTime(),
        })
      );
      const result = response?.result;
      const timeSheetData = result?.timeSheetData || [];
      const entries: any[] = [];
      timeSheetData.forEach((group: any) => {
        const dateLabel = group?.date
          ? new Date(group.date).toDateString()
          : "-";
        (group?.data || []).forEach((user: any) => {
          const userName = `${user?.user_details?.first_name || ""} ${
            user?.user_details?.last_name || ""
          }`.trim() || "-";
          const type = user?.event === "end" ? "Auto" : "Manual";
          const logDate = user?.time_log_date
            ? new Date(user.time_log_date).toDateString()
            : "-";
          const start = user?.event === "manual"
            ? "-"
            : user?.start_time
              ? new Date(user.start_time).toLocaleTimeString()
              : "-";
          const end = user?.event === "manual"
            ? "-"
            : user?.end_time
              ? new Date(user.end_time).toLocaleTimeString()
              : "-";
          const hours = user?.hours ? this.formatHours(user.hours) : "-";
          const note = this.stripHtml(user?.comment || "");
          entries.push({
            date: dateLabel,
            user: userName,
            type,
            logDate,
            start,
            end,
            hours,
            note,
          });
        });
      });
      this.timeLogPrintData = {
        entries,
        totalHours: result?.totalHours || "00:00",
        estimatedHours: result?.time_sheet_estimated_hr || "00:00",
      };
    } catch (_err) {
      this.timeLogPrintData = { entries: [] };
    }
  }

  private formatHours(value: any) {
    if (!value) return "-";
    return value;
  }

  closeDialog() {
    this.taskService.subTaskDetails([]);
    this.taskService.selectedTaskDetails.next("");
    this.discussionSocketService.emit(discussionSocketEvents.LEAVE_ROOM, {
      id: this.selectedRoom?._id,
    });
    if(this.isRefreshTaskPageBoolean){
      return this.dialogRef.close(true);
    }
    this.dialogRef.close(false);
  }
  
  isRefreshTaskPage(event?:any){
    if(event){
      return this.isRefreshTaskPageBoolean = event;
    }
  }
}
